import { reactive } from 'vue';

const DEFAULT_DURATION_MS = 3600;
let nextToastId = 0;

const state = reactive({
  toasts: []
});

function normalizeToastMessage(value) {
  let text = String(value ?? '');

  // Corrige textos mojibake comuns (UTF-8 lido como Latin-1).
  if (/[ÃÂ]/.test(text)) {
    try {
      text = decodeURIComponent(escape(text));
    } catch (e) {
      // keep original text when decoding fails
    }
  }

  // Ajustes de acentuação mais comuns no projeto.
  return text
    .replace(/\bNao\b/g, 'Não')
    .replace(/\bnao\b/g, 'não')
    .replace(/\bVoce\b/g, 'Você')
    .replace(/\bvoce\b/g, 'você')
    .replace(/\bpossivel\b/g, 'possível')
    .replace(/\binvalido\b/g, 'inválido')
    .replace(/\bInvalido\b/g, 'Inválido')
    .replace(/\bApos\b/g, 'Após')
    .replace(/\bapos\b/g, 'após')
    .replace(/\batras\b/g, 'atrás')
    .replace(/\bconexao\b/g, 'conexão')
    .replace(/\bConexao\b/g, 'Conexão')
    .replace(/\bnao autenticado\b/g, 'não autenticado');
}

function enqueueToast(message, options = {}) {
  if (!message) return null;

  const duration =
    typeof options.duration === 'number' ? Math.max(0, options.duration) : DEFAULT_DURATION_MS;

  const toast = {
    id: ++nextToastId,
    message: normalizeToastMessage(message),
    type: options.type || 'info',
    duration
  };

  state.toasts.push(toast);

  if (duration > 0) {
    window.setTimeout(() => {
      removeToast(toast.id);
    }, duration);
  }

  return toast.id;
}

export function removeToast(id) {
  const index = state.toasts.findIndex((toast) => toast.id === id);
  if (index !== -1) {
    state.toasts.splice(index, 1);
  }
}

export function toast(message, options = {}) {
  return enqueueToast(message, options);
}

export function toastSuccess(message, options = {}) {
  return enqueueToast(message, { ...options, type: 'success' });
}

export function toastError(message, options = {}) {
  return enqueueToast(message, { ...options, type: 'error' });
}

export function toastWarning(message, options = {}) {
  return enqueueToast(message, { ...options, type: 'warning' });
}

export function useToast() {
  return {
    toasts: state.toasts,
    toast,
    toastSuccess,
    toastError,
    toastWarning,
    removeToast
  };
}
